import {
  Maybe,
  VerticalID,
  Args,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import { planFeatureIconString } from '../../fragments/__generated__/PlanFeatureIcon'

import { featureFragmentString } from '../../fragments/__generated__/FeatureFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { minimalSponsorFragmentString } from '../../fragments/__generated__/MinimalSponsorFragment'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { planFeatureFragmentString } from '../../fragments/__generated__/PlanFeatureFragment'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import loginUserRawString from '../LoginUser.graphql'

const loginUserString = [
  loginUserRawString,
  accountFragmentString,
  expenseReloadString,
  bankAccountFragmentString,
  addressFragmentString,
  planFeatureIconString,
  featureFragmentString,
  storefrontString,
  minimalSponsorFragmentString,
  stripeSubscriptionString,
  subscriptionMetadataString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  creditCardFragmentString,
  subscriptionFeaturesString,
  planFeatureFragmentString,
  userSettingsFragmentString,
].join('\n\n')

export type LoginUserData = {
  loginUser: {
    success: boolean
    message: Maybe<string>
    oldUser: Maybe<boolean>
    account: Maybe<AccountFragment>
  }
  createUserLoginLink: {
    link: Maybe<string>
  }
}

export type LoginUserVariables = {
  username: string
  password: string
  verticalId: VerticalID
  queryParams: Args
}

export type LoginUser = Operation<LoginUserData, LoginUserVariables>

export const LoginUser = ({
  username,
  password,
  verticalId,
  queryParams,
}: LoginUserVariables): LoginUser => ({
  query: loginUserString,
  variables: {
    username,
    password,
    verticalId,
    queryParams: Args(queryParams),
  },
})
